import geolocation from "../images/geolocation-api.jpg";
import distanceTwoLoc from "../images/distance-two-locations.jpg";
import svgAdvantages from "../images/svg-advantages-and-disadvantages.jpg";
import jsIcon from "../images/js-icon.png";
export const BlogContent = 
  [
    {
      link: "https://darshansite.com/blog/pos-customizations",
      
      img: distanceTwoLoc,
      icon: jsIcon,
      name: "How to Manage Scalable POS Customizations",
      excerpt: `Managing customizations in a POS system can be challenging, especially when items have varying customization options. Learn techniques to make your customizations scalable and user-friendly.`,
      category: "Web Development",
      date: "15 hours ago"
    },
    {
      link: "https://darshansite.com/blog/mongodb-menu-structure",
      img: svgAdvantages,
      icon: jsIcon,
      name: "Designing a Menu Structure in MongoDB",
      excerpt: `Discover how to create a flexible and dynamic menu structure in MongoDB for restaurant POS applications. This guide covers categories, submenus, and modifiers to streamline your database design.`,
      category: "Database",
      date: "2 days ago"
    },
    {
      link: "https://darshansite.com/blog/pos-admin-panel",
      img: geolocation,
      icon: jsIcon,
      name: "Building an Admin Panel for a Restaurant POS",
      excerpt: `An admin panel is crucial for managing menus, modifiers, and reporting in a POS system. Explore how to develop a robust admin panel for seamless restaurant management.`,
      category: "Web Development",
      date: "1 day ago"
    }
  ];
  